import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';
import { isOnboardingIncomplete } from '../utils/onboarding-status.util';

export const notAuthGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  if (!storageService.hasToken()) {
    return router.createUrlTree(['/']);
  }

  if (isOnboardingIncomplete(storageService.getDataUser())) {
    return router.createUrlTree(['/']);
  }

  return true;
};
